/**
 *
 * @param {number} proveedorId
 * @param {string} search
 * @returns
 */
export function pagosSinComplementoQuery(proveedorId, search = '') {
  const like = { $like: `%${search}%`}
  const filter = search.length > 0 ?
    {
      $or: [
        { '$factura.sReferencia$': like },
        { '$facturaSub.sReferencia$': like },
      ]
    } :
    {}

  const q = {
    model: 'TesPagoFactura',
    attributes: [
      'iId',
      'dTipoCambio',
    ],
    include: [
      {
        as: 'pago',
        required: true,
        attributes: [
          // 'sNumeroCheque',
          'sNumeroTransferencia',
          'dFechaPago',
        ],
        where: {
          iActivo: true,
          iIdProveedor: proveedorId || -2,
          sEstado: 'PAGADO',
        }
      },
      {
        as: 'factura',
        required: false,
        attributes: [
          'sUUID',
          'sReferencia',
          'dFechaIngreso',
        ]
      },
      {
        as: 'facturaSub',
        required: false,
        attributes: [
          'sUUID',
          'sReferencia',
          'dFechaIngreso',
        ]
      },
    ],
    where: {
      $and: [
        {
          iActivo: true,
          iIdComplementoPago: null,
        },
        filter,
      ]
    },
  }

  return q
}
